import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
//import { Group } from '../users/interfaces/group';
//import { HttpClient } from '@angular/common/http';
//import { Observable } from 'rxjs';
//import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-callback',
  template: ``,
})
export class AuthCallbackComponent {

  //private router: Router, private http: HttpClient
  constructor(private router: Router,
    private authService: AuthService) {
    this.router.navigate(['home'])
    /*
    if (!this.validPerfilAdmin()) {
      this.router.navigate(['chat']);
    } else {
      this.router.navigate(['home']);
    }
    */
    
    if (this.authService.isAdmin) {
      this.router.navigate(['home']);
    } else {
      this.router.navigate(['chat']);
    }
    
   }
   /*
   validPerfilAdmin(): boolean{
    this.getValidPerfilAdmin().subscribe ({
      next: (res) =>{
        console.log('Res ' + res);
        return res;
      },
      error: (err) =>{
        console.log('Erro...:' + err);
        return false;
      }
    });
    return false;
  }
  getValidPerfilAdmin(): Observable<boolean>{
    return this.http.get<boolean>(`${environment.apiGatewayUrl + environment.endPointSufix}/authorize/validPerfilAdmin`);
  }
  */
}
